import { useEffect } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useState } from "react";
import PageTopTitle from "../../components/shared/PageTopTitle";
import GivenMapSection from "../../components/load/mainSections/GivenMapSection";
import { useNavigate } from "react-router-dom";
import loadIcon from "../../images/svg/topPages/load.svg"
import unloadIcon from "../../images/svg/topPages/unload.svg"
import loadMobile from "../../images/svg/topPages/load-mobile.svg"
import truckMobile from "../../images/svg/topPages/truck-mobile.svg"
import paketlemeTypes from "../../utils/yukOptions/paketlemeTypesOptions";
import formatConverter from "../../helper/formatConverter";
import yayinlamaSecenekleriOptions from "../../utils/yukOptions/yayinlamaSecenekleriOptions";
import { getRoutePointDisplayName } from "../../helper/shipment/safeShipmentListItem";

const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    .map-container {
        width: 100%;
        height: 300px;
        display: flex;
        flex-direction: column;

        .map-side {
            width: 100%;
            height: 300px;
            border-radius: 10px;
        }
    }
    .content {
      gap: 60px;
      margin: 0 30px;
      margin-top: 30px;
        .content-item{
            font-size: var(--font-size-xs);
            font-weight: var(--font-weight-md);
        }
        .title{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
        }
        .payment-card{
            border: 1px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
            border-radius: 12px;
            padding: 20px;
            display: flex;
            flex-direction: column;
            gap: 5px;
            .seperator{
                width: 70%;
                border: 1px solid;
                border-color: ${({ theme }) => theme.mainBorderColor};
                margin-block: 5px;
            }
        }

        .load-unload{
            display: flex;
            gap: 20px;
            height: 100%;
            margin-block: 40px;
            .x-seperator{
                height: auto;
                border: 1px solid;
                border-color: ${({ theme }) => theme.mainBorderColor};
            }
            .load-side{
                width: 50%;
                height: 100%;
                .loads, .route-list{
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                }
            }
        }

        .detail-container{
            display: flex;
            gap: 20px;
            .detail-side{
                width: 50%;
                display: flex;
                flex-direction: column;
                gap: 20px;
                .detail{
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    .detail-img{
                        height: 30px;
                    }
                }
            }
           
        }
    }
  }
  .bold{
    border-bottom: 1px solid;
    border-color: ${({ theme }) => theme.mainBorderColor};
    width: fit-content;
  }
  .vehicle{
    padding-left: 10px;
  }
`;

const DetailLoadPage = () => {
  const { theme } = useSelector((state) => state.layout);
  const { loadItemData } = useSelector((state) => state.loadList);
  const [route, setRoute] = useState([]);
  const navigate = useNavigate()

  useEffect(() => {
    const list = loadItemData?.routePoints?.$values.map((innerItem, i) => {
      if (i === 0 || i === loadItemData?.routePoints?.$values?.length - 1) {
        return {
          lat: parseFloat(innerItem.lat),
          lng: parseFloat(innerItem.lng),
        };
      } else {
        return {
          location: {
            lat: parseFloat(innerItem.lat),
            lng: parseFloat(innerItem.lng),
          },
        };
      }
    });
    setRoute(list);
  }, []);


  if(!loadItemData){
    return navigate("/yukler-listesi")
  }

  return (
    <Container theme={theme}>
      <div className="wrapper">
        <PageTopTitle title={"Yük Detay"} position="sticky" />
        <div className="map-container">
            <div className="map-side">
                <GivenMapSection
                    route={route}
                    defaultLocation={{ lat: 38.75, lng: 33.75 }}
                    zoom={5}
                />
            </div>
        </div>
        <div className="content">
          <div className="payment-card">
            <p className="title">Ödeme</p>
            <div className="content-item">{loadItemData?.freight} TL (Hedef Fiyatınız Yayınlanıyor)</div>
            <div className="seperator"></div>
            <div className="content-item">{loadItemData?.paymentType}</div>
            <div className="content-item">Yakıt %{loadItemData?.yakıtVarYüzde}</div>
            {loadItemData?.commissionPaymentId !== 0 && <div className="content-item">Komisyon: {loadItemData?.commissionPaymentId === 1 && "%"} {loadItemData?.commissionPayment} {loadItemData?.commissionPaymentId === 2 && "TL"}</div>}
          </div>

          <div className="load-unload">
            <div className="load-side">
                <img src={loadIcon} alt="" />
                <div className="loads">
                    <p className="title">Yükleme</p>
                    <div className="content-item">{loadItemData?.planningLoadDate} - {loadItemData?.planningLoadTime}</div>
                    <div className="route">
                        {loadItemData?.routePoints?.$values
                            .filter((item) => item.loadOrUnload === 0)
                            .map((routeItem, i) => (
                            <div className="route-list">
                                <div className="content-item bold">
                                    {i + 1}. {getRoutePointDisplayName(routeItem)}
                                </div>
                                <div className="content-item">{routeItem.location}</div>
                                <div className="content-item">{routeItem.address}</div>
                                {routeItem.loadMethods.$values?.length > 0 &&
                                    <div className="content-item">
                                        {routeItem.loadMethods.$values.map((item) => `${item.name} `)}
                                    </div>
                                }
                                {routeItem.routePointPersonName &&
                                    <div className="content-item">
                                        {routeItem.routePointPersonName}
                                    </div>
                                }
                                {routeItem.routePointPersonPhoneNumber && 
                                    <div className="content-item">
                                        {routeItem.routePointPersonPhoneNumber}
                                    </div>
                                }
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            
            <div className="x-seperator" />

            <div className="load-side">
                <img src={unloadIcon} alt="" />
                <div className="loads">
                    <p className="title">Boşaltma</p>
                    <div className="content-item">{loadItemData?.planningUnloadDate} - {loadItemData?.planningUnloadTime}</div>
                    <div className="route">
                        {loadItemData?.routePoints.$values
                            .filter((item) => item.loadOrUnload === 1)
                            .map((routeItem, i) => (
                            <div className="route-list">
                                <div className="content-item bold">
                                    {i + 1}. {getRoutePointDisplayName(routeItem)}
                                </div>
                                <div className="content-item">{routeItem.location}</div>
                                <div className="content-item">{routeItem.address}</div>
                                {routeItem.loadMethods.$values?.length > 0 &&
                                    <div className="content-item">
                                        {routeItem.loadMethods.$values.map((item) => `${item.name} `)}
                                    </div>
                                }
                                {routeItem.routePointPersonName &&
                                    <div className="content-item">
                                        {routeItem.routePointPersonName}
                                    </div>
                                }
                                {routeItem.routePointPersonPhoneNumber && 
                                    <div className="content-item">
                                        {routeItem.routePointPersonPhoneNumber}
                                    </div>
                                }
                            </div>
                        ))}
                    </div>
                </div>
            </div>
          </div>


          <div className="detail-container">
            <div className="detail-side">
                <div className="detail">
                    <div className="detail-img">
                        <img src={loadMobile} alt="" />
                    </div>
                    <p className="title">Yük</p>
                    {loadItemData.senderName &&
                        <div className="content-item">{loadItemData.senderName}</div>
                    }
                    <div className="content-item">
                        {loadItemData.isParsiyel ? "LTL(Parsiyel)" : "FTL(Komple Araç)"}
                    </div>
                    {loadItemData.LoadUnitId === 3 ? (
                        <div className="content-item">
                        Basar Tonaj{" "}
                        {loadItemData.loadBulk > 0 &&
                            ` - ${loadItemData.loadBulk} ${loadItemData.loadBulk > 0 && "m3"}`}
                        </div>
                    ) : (
                        <div className="content-item">
                        {loadItemData.loadQuantity} {loadItemData.loadUnit}{" "}
                        {loadItemData.loadBulk > 0 &&
                            ` - ${loadItemData.loadBulk} ${loadItemData.loadBulk > 0 && "m3"}`}
                        </div>
                    )}
                    <div className="content-item">{loadItemData.loadType}</div>
                    {loadItemData.loadDescription && <div className="content-item">{loadItemData.loadDescription}</div>}
                    {loadItemData?.packingingTypes?.$values?.map((item) => {
                        return (
                            <div className="content-item">
                                {paketlemeTypes?.find((innerItem) => {
                                    return innerItem?.id === item?.packagingUnitId
                                })?.name}
                            </div>
                        )
                    })}
                    <div className="content-item">Sigorta Değeri: {loadItemData?.loadValue} TL</div>
                </div>
                
                <div className="detail">
                    <div className="title">Diğer Bilgiler</div>
                    <div className="content-item">
                        {yayinlamaSecenekleriOptions?.find(
                            (yItem) => yItem?.id === loadItemData?.publishingTypeId
                        )?.text}
                    </div>
                    <div className="content-item">
                        {formatConverter(loadItemData.distance, 0)} Km
                    </div>
                    <div className="content-item">{loadItemData?.projectName}</div>
                </div>
            </div>
            <div className="detail-side vehicle">
                <div className="detail">
                    <div className="detail-img">
                        <img src={truckMobile} alt="" />
                    </div>
                    <p className="title">Araç</p>
                    <div className="content-item">{loadItemData?.truckQuantity} Adet</div>
                    <div className="content-item">{loadItemData?.truckType}</div>
                    <div className="content-item">{loadItemData?.groundType}</div>
                </div>
            </div>
          </div>
        </div>
        
      </div>
    </Container>
  );
};

export default DetailLoadPage;
